import React from "react";

const Logo: React.FC<{ size?: number }> = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="14" fill="url(#logo-bg)" />
    <path
      d="M18 18v28M18 32h12M30 18v28"
      stroke="#0a0a0a"
      strokeWidth="5.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="44" cy="24" r="5" fill="#0a0a0a" />
    <path
      d="M44 30v10c0 3-2 6-6 6"
      stroke="#0a0a0a"
      strokeWidth="5.5"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient id="logo-bg" x1="0" y1="0" x2="64" y2="64">
        <stop stopColor="#22c55e" />
        <stop offset="1" stopColor="#16a34a" />
      </linearGradient>
    </defs>
  </svg>
);

export default Logo;
